module.exports = __webpack_public_path__ + "static/mijnprestalogobalk_wit-b5bd26601b42cabccad58a9676b24f4d.svg";